export function showTrustPilotLink(trackingData) {
  return (
    !!trackingData?.trustpilotInvitationLink &&
    trackingData?.toAddress?.postcode &&
    trackingData?.toAddress?.postcode % 10 !== 5
  );
}
